import { arraySchema, objectSchema } from "vue-utils"
import type { EmergencyPhase, Id, Nullable, SortDirection } from "."
import { IncidentLogSummary } from "./IncidentLogSummary"
import type { IncidentStatus } from "./IncidentStatus"

export interface SearchIncidentsResult {
	globalTotal: number
	totalItems: number
	pageSize: number
	totalPages: number

	incidents: IncidentLogSummary[]
}

export const SearchIncidentsResult = objectSchema<SearchIncidentsResult>({
	globalTotal: Number,
	totalItems: Number,
	pageSize: Number,
	totalPages: Number,

	incidents: arraySchema(IncidentLogSummary),
})

export interface SearchIncidentsRequest {
	pageSize: number
	page: number
	filter: SearchIncidentsFilter
	sortBy?: IncidentsSortBy
	sortDirection?: SortDirection
}

export interface SearchIncidentsFilter {
	year: Nullable<number>
	statuses: IncidentStatus[]
	incidentTypeIds: Id[]
	emergencyPhases: EmergencyPhase[]
}

export enum IncidentsSortBy {
	IncidentId = "incidentId",
	IncidentTime = "incidentTime",
	CreatedAt = "createdAt",
	IncidentType = "incidentType",
	EmergencyPhase = "emergencyPhase",
	NameOfVesselOrCasualty = "nameOfVesselOrCasualty",
	PersonsAtRisk = "personsAtRisk",
	SignOff = "signOff",
	Status = "status",
}
